import { useCallback, useEffect, useRef, useState } from 'react';
import DashboardSidebar from './Sections/DashboardSidebar';
import DashboardTopbar from './Sections/DashboardTopbar.jsx';
// import SetupPage from './DashboardPages/Setup';
import { useSearchParams } from 'react-router-dom';
// import Setup from './Setup/Setup'
import { useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import allTabs, { tabs, sales_channels, bottom_tabs } from './DashboardTabs';
import DashboardSubTabs from '../components/ui/DashboardSubTabs';
import LayeredDashboard from './LayeredDashboard';
import systemSlice from '../redux/systemSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import themeSlice from '../redux/themeSlice';
import CreateAction from '../components/operational/createAction';
const Dashboard = ({ activeTab, children }) => {


  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [pageRendered, setPageRendered] = useState(false)
  const [renderTabs, setRenderTabs] = useState([])
  const [mainTab, setMainTab] = useState({})
  const contentRef = useRef(null)
  const activeSubTabs = useSelector((state) => state.systemSlice?.activeSubTabs)


  useEffect(() => {
    const activeTabs = [...activeTab?.activeTabs]
    const mainTabId = activeTabs?.[0]
    const mainTabData = allTabs.find(tab => tab.id === mainTabId)
    setMainTab(mainTabData)
    activeTabs.shift()
    const tabsToRender = activeTabs?.map(tabId => {
      const tabData = allTabs.find(tab => tab.id === tabId)
      return tabData
    })
    dispatch(systemSlice.actions.setActiveSubTabs(activeTabs));
    setRenderTabs(tabsToRender)
    setPageRendered(true)
  }, [activeTab])


  return (
    <div className=" flex flex-row  bg-[#F8F8F8]">

      <div className="flex overflow-hidden flex-col w-[100%] h-[100dvh] border">
        <DashboardTopbar activeTab={mainTab} titlePointTos={mainTab?.titlePointTos} />
        <div className='h-[calc(100dvh-70px)] overflow-auto duration-400' ref={contentRef}>
          {pageRendered &&
            <>
              {(mainTab?.subTabs?.length > 0 && !mainTab?.isMain) ?
                <DashboardSubTabs activeTab={mainTab} subTabs={mainTab.subTabs}></DashboardSubTabs> :
                activeTab?.component ? <activeTab.component tab={activeTab}></activeTab.component> : <></>
              }
              {renderTabs?.filter(tab => window.location.href.includes(tab.pointTo))?.map(tab => {
                return <LayeredDashboard isActive={activeSubTabs.includes(tab.id)} tab={tab} ></LayeredDashboard>
              })}
            </>
          }
        </div>
      </div>
    </div>

  );
};

export default Dashboard;
